window.addEventListener('load', fadeInEffect);

function fadeInEffect() {
    const $documentElement = document.documentElement;
    $documentElement.classList.remove('nojs');
}